import { useChartDefinitionsContext } from '@/components/ChartDefinitionsContext';
import { useTheme } from '@simplywallst/ui-core';

interface Props {
  y: number;
  yearX: number;
  x: number;
  height: number;
}

const Year = ({ y, yearX, x, height }: Props) => {
  const theme = useTheme();
  const { yearMarkerGradient } = useChartDefinitionsContext();
  return (
    <>
      <rect
        y={y}
        x={yearX}
        width={Math.abs(x - yearX)}
        height={height}
        fill={yearMarkerGradient}
      />
      <rect
        y={y}
        x={yearX}
        width="1"
        height={height}
        fill={theme.color.brand01}
        fillOpacity={0.1}
      />
    </>
  );
};

export default Year;
